import React from 'react';
import EditCollectionCard from '@/components/Collections/Settings/EditCollectionCard';
import PermissionsDetailCard from '@/components/Collections/Settings/PermissionsDetailCard';
import InviteCollaboratorsCard from '@/components/Collections/Settings/InviteCollaboratorsCard';
import Container from 'react-bootstrap/Container';
import classes from '@/components/Collections/Collection/Collection.module.scss';

const CollectionSettings = ({ account, collection, updateCollection }) => {
  return (
    <Container className={classes.collectionSettingWrapper}>
      <EditCollectionCard collection={collection} account={account} updateCollection={updateCollection} />
      <br />
      <PermissionsDetailCard collection={collection} account={account} updateCollection={updateCollection} />
      <br />
      <InviteCollaboratorsCard collection={collection} account={account} updateCollection={updateCollection} />
    </Container>
  );
};

export default CollectionSettings;
